<template>
	<page enable-flex>
		<view-list ref="view" work-type="12" :search="{scan: true}">
			<template #link>
				<topbar-link v-if="auth('b_app_order_online_view')" count="0" @click="mp.navigateWeb('/sales/order/online/extra')">超卖</topbar-link>
			</template>
			
			<template #filter>
				<m-search>
					<m-search-item label="订单号">
						<c-input name="keyword"></c-input>
					</m-search-item>
					<m-search-item label="发货单号">
						<c-input name="express_no"></c-input>
					</m-search-item> 
					<m-search-item label="销售渠道">
						<c-select name="channel_id" async @search="searchChannel"></c-select>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #number>
						{{data.order_no}}
					</template>

					<template #state>
						<c-state dict="SALES_ORDER_STATE" :value="data.display_state == null ? data.order_state : data.display_state" type="state" @click="tipsHandle(data)">
							<template v-if="data.abnormal_flag == 1" #prepend>
								<span class="tf" style="color: #e53e3e;">&#xe6ba;</span>
							</template>
						</c-state>
					</template>

					<template #areaTag>
						<c-state dict="LEVEL_TYPE" :value="data.level_type" type="hollow"></c-state>
					</template>

					<template #areaName>
						{{[data.brand_name, data.model_name, data.memory_name, data.color_name].filter(item => item).join(' ') || '-'}}
					</template>

					<template #area>
						<c-field label="背贴码">{{data.produce_code}}</c-field>
						<c-field label="IMEI">{{data.imei}}</c-field>
						<c-field label="销售渠道">{{data.channel_name}}</c-field>
						<c-field label="售卖类型"><c-state dict="SALE_SELL_TYPE" :value="data.sell_type"></c-state><span v-if="data.sell_type == 2 && dismantleText(data.dismantle_items)">（{{dismantleText(data.dismantle_items)}}）</span></c-field>
						<c-field label="售出价"><span style="color: #FF6900;">￥{{data.sale_price}}</span></c-field>
					</template>

					<template #operate>
						<c-button v-if="auth('b_app_order_online_view')" hollow @click="globalDialog('salesOrderDetail', {props: {orderType: 2, orderId: data.order_id}})">详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		methods: {
            dismantleText(value) {
                if (!value) return '';
                let items = value;
                if (typeof items === 'string') {
                    try { items = JSON.parse(items); } catch (e) { return items; }
                }
                if (!Array.isArray(items)) return '';
                return items.map(item => typeof item === 'string' ? item : item && (item.name || item.value)).filter(Boolean).join('、');
            },

			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			tipsHandle(data) {
				if (data.abnormal_flag == 1) {
					this.$confirm({
						title: '异常关单',
						message: '不可发货' + (data.abnormal_remark ? '。原因：' + data.abnormal_remark : ''),
						buttonName: '我知道了',
						cancelButton: false
					})
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>